<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">{{$t('Create_a_New_Vehicle')}}</h4>
                <p class="text-subtitle">{{ $t("Vehicle_Creation_Form")}}</p>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="mt-2">
            <v-col cols="12" md="6">
                <VehicleForm ref="form" v-model="form"/>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-btn color="primary" block @click="handleSave" :loading="loading">
                    <v-icon left>mdi-content-save</v-icon>
                    {{$t('save')}}
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-btn depressed block @click="handleCancel">
                    {{$t('cancel')}}
                </v-btn>
            </v-col>
        </v-row>
        <PAlert v-model="alert.model" v-bind="alert"/>
    </v-container>
</template>

<script>
import VehicleForm from './../../components/fleet/VehicleForm.vue';
import PAlert from './../../components/common/PAlert.vue';
import { v4 as uuid } from 'uuid';
import vehicleAPI from './../../services/fleet/vehicle';
export default {
    components: {
        VehicleForm,
        PAlert
    },
    data() {
        return {
            form: {},
            alert: {
                title: this.$t("alert_title"),
                content: "",
                callback: null,
                model: false
            },
            idempotentKey: null,
            loading: false
        }
    },
    methods: {
        handleSave() {
            this.alert = {...this.alert, content: this.$t("are_you_sure_you_want_to_save"), model: true, callback: this.save}
        },
        save() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            vehicleAPI.create({...this.form, idempotentKey: this.idempotentKey}).then(response => {
                this.$router.replace({ name: "VehicleDisplay", params: { vehicleID: response.data.id } })
            }).finally(() => {
                this.loading = false;
            })
        },
        handleCancel() {
            this.alert = {...this.alert, content: this.$t('are_you_sure_cancel'), model: true, callback: this.cancel}
        },
        cancel() {
            this.$router.back();
        }
    },
    created() {
        this.idempotentKey = uuid();
    }
}
</script>

<style>

</style>